"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */

var initializeHotjarQueue = function initializeHotjarQueue() {
  window.hj = window.hj || function () {
    (window.hj.q = window.hj.q || []).push(arguments);
  };
};
var withHotjar = function withHotjar(cb) {
  return function () {
    initializeHotjarQueue();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cb.apply(void 0, [window.hj].concat(args));
  };
};
var trigger = withHotjar(function (hj, triggerEvent) {
  hj('trigger', triggerEvent);
});
var recordTag = withHotjar(function (hj, tagsArray) {
  hj('tagRecording', tagsArray);
});
var _default = {
  trigger: trigger,
  recordTag: recordTag
};
exports.default = _default;
//# sourceMappingURL=HotjarConnector.js.map